import React from 'react';

import { BaseIconProps } from './icon-types';

export const RoundCheck = ({ fill }: BaseIconProps) => (
  <g transform="matrix(67.50869,0,0,67.50869,-66.427457,84.646103)">
    <path
      d="m 3.865,4.896 3.65,3.688 6.587,-6.693 a 1.39,1.39 0 0 1 1.974,0 1.41,1.41 0 0 1 0,1.986 L 8.724,11.35 A 1.387,1.387 0 0 1 7.518,12.007 1.387,1.387 0 0 1 6.316,11.354 L 1.89,6.883 a 1.411,1.411 0 0 1 0,-1.987 1.39,1.39 0 0 1 1.974,0 z"
      fill={fill}
    />
    <path
      fill="none"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="50"
      d="m 3.865,4.896 3.65,3.688 6.587,-6.693 a 1.39,1.39 0 0 1 1.974,0 1.41,1.41 0 0 1 0,1.986 L 8.724,11.35 A 1.387,1.387 0 0 1 7.518,12.007 1.387,1.387 0 0 1 6.316,11.354 L 1.89,6.883 a 1.411,1.411 0 0 1 0,-1.987 1.39,1.39 0 0 1 1.974,0 z"
    />
  </g>
);
